module.exports = __webpack_public_path__ + "img/chongzhi_banner@2x.f039fa10.png";